<template>
    <div class="logo" @click="$router.push('/')">
        <img
             src="@/assets/images/logo.svg" alt=""
             :width="width"
             :height="height"
        >
    </div>
</template>
<script>
    export default {
        props: {
            width: {
                type: [Number, String],
                required: true
            },
            height: {
                type: [Number, String],
                required: true
            }
        }
    }
</script>
<style lang="sass">
.logo
    cursor: pointer
</style>
<style lang="sass">
.logo
    cursor: pointer
</style>